const typePolicies = {};

export default typePolicies;
